import React, { Component } from 'react';
import { HomeFilled, PlusCircleFilled, MinusCircleFilled, InfoCircleFilled, LeftCircleOutlined, RightCircleOutlined,FileDoneOutlined,CloseOutlined } from '@ant-design/icons';
import { Modal, Spin, Button, Carousel, Tabs,Table,Tooltip,Empty } from 'antd';
import { roomtypeSchema, includesSchema, excludesSchema } from './../../../schema/new-estimate-charges-cash';
import { nmePopupSchema } from './../../../schema/insurance-form';
import hideInEXStore from '../../../reduxStore/dataEvent';
import Tableantd from '../../../components/version2form_component/table/antd';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import { optionsStore, excludesTableStore, excludesUpdateTableStore } from './../../../selectStore.jsx'
import Finanical_clearance from './finanical-clearance';
import Counselling_upload from './uploadDocument';
import New_Counselling_upload from './newFileUploadDocuments.js';
import AdmissionAdvices from './admissionAdvices.js';
import ReactToPrint from "react-to-print";
import PatientCheckIn from './patientCheckIn';

import Storage from '../../../services/local-store';
import moment from 'moment';
import InsurancePreview from '../../../modules/Counselling/newCounsellingForms/insurance_preview';
import rootReduxStore from '../../../reduxStore/rootStore';
import losReduxStore from '../../../reduxStore/losStore';
import specialityReduxStore from '../../../reduxStore/specalityStore';
const $ = require('jquery');
const excludes_schema = {
    feilds: [{
        id: 1,
        name: 'exlcudes',
        title: 'Excludes',
        visible: true,
        Specification: {
            'type': 'table',
            // 'add_more': true,
            'add_more_title': 'Add Excludes',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "15%" }, { 'id': 3, 'text': 'Quantity', width: "18%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "18%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "18%" }, { 'id': 6, 'text': 'Action', width: "5%" }],
            'table_body': [
                {
                    'id': 1,
                    'text': 'item_service',
                    'type': 'Item / Service',
                    'input_feild': [],
                    'feilds': [{

                        id: 1,
                        name: 'excludes_service_id',
                        title: '',
                        visible: true,
                        icon: 'number',
                        element: 'select',
                        required: true,
                        type: 'select',
                        placeholder: 'Select Service',
                        rules: [],
                        errors: [],
                        value: null,
                        valid: false,
                        state: '',
                        disable: false,
                        className: 'w-100',
                        row_group: 'Routine',
                        column_group: 'qty',
                        table: 'exlcudes',

                    }, {
                        id: 1,
                        name: 'qty',
                        title: '',
                        visible: true,
                        icon: 'number',
                        element: 'input',
                        required: true,
                        type: 'number',
                        placeholder: 'Item / Service Quantity',
                        rules: [],
                        errors: [],
                        value: null,
                        valid: false,
                        state: '',
                        disable: false,
                        className: 'w-100',
                        row_group: 'Routine',
                        column_group: 'qty',
                        table: 'exlcudes',
                    }, {
                        id: 1,
                        name: 'rate',
                        title: 'Item / Service Rate',
                        visible: true,
                        icon: 'number',
                        element: 'input',
                        required: true,
                        type: 'number',
                        placeholder: 'Item / Service Rate',
                        rules: [],
                        errors: [],
                        value: null,
                        valid: false,
                        state: '',
                        disable: false,
                        className: 'col-3',
                        row_group: 'Routine',
                        column_group: 'rate',
                        table: 'exlcudes',
                    }, {
                        id: 1,
                        name: 'amount',
                        title: 'Item / Service Amount',
                        visible: true,
                        icon: 'number',
                        element: 'input',
                        required: true,
                        type: 'number',
                        placeholder: 'Item / Service Amount',
                        rules: [],
                        errors: [],
                        value: null,
                        valid: false,
                        state: '',
                        disable: true,
                        className: 'col-3',
                        row_group: 'Routine',
                        column_group: 'amount',
                        table: 'exlcudes',
                    }, {
                        id: 1,
                        name: 'action',
                        title: '--',
                        visible: true,
                        element: 'action',

                    },]
                }
            ],
            'add_more_feilds': [{

                id: 1,
                name: 'excludes_service_id',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Select Service',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'w-100',
                row_group: 'Routine',
                column_group: 'qty',
                table: 'exlcudes',
            }, {
                id: 1,
                name: 'qty',
                title: 'Item / Service Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Item / Service Quantity',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'Highend',
                column_group: 'qty',
                table: 'exlcudes',
            }, {
                id: 1,
                name: 'rate',
                title: 'Item / Service Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Item / Service Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'Highend',
                column_group: 'rate',
                table: 'exlcudes',
            }, {
                id: 1,
                name: 'amount',
                title: 'Item / Service Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Item / Service Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'Highend',
                column_group: 'amount',
                table: 'exlcudes',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
            }],
        }
    }]
}
export { excludes_schema }
class Side_feild extends Component {
    constructor(props) {
        super(props)
        this.state = {
            'loadding': false,
            modal1Visible: false, // includes
            modal2Visible: false, // Excludes
            modal3Visible: false, // nme
            modal4Visible: false, // rooms
            excludesSchema: excludesSchema['feilds'],
            includesSchema: includesSchema['feilds'],
            roomtypeSchema: roomtypeSchema['feilds'],
            nmePopupSchema: nmePopupSchema['feilds'],
            rooms: [],
            roomImages: [],
            hide: true,
            hiderooms: true,
            roomTabs: [],
            consentviewModel:false,
            consents_head: [
                // {
                //     'id': 1,
                //     'title': 'S.No.',
                //     'key': 's_no',
                //     'dataIndex': 'consent_id',
                //     'visible': true,
                //     'className': 'text-center'
                // },
                {
                    'id': 2,
                    'title': 'Consent ID',
                    'key': 'consent_id',
                    'dataIndex': 'consent_id',
                    'fixed': 'left',
                    'visible': true,
                    'className': null
                },{
                    'id': 3,
                    'title': 'IP No.',
                    'key': 'ip_no',
                    'dataIndex': 'ip_no',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 5,
                    'title': 'UMR No.',
                    'key': 'umr_no',
                    'dataIndex': 'umr_no',
                    'visible': true,
                    'className': null
                }, {
                    'id': 4,
                    'title': 'consent name',
                    'key': 'consent_name',
                    'dataIndex': 'consent_name',
                    'visible': true,
                    'className': null
                },  {
                    'id': 4,
                    'title': 'consent type',
                    'key': 'consent_type',
                    'dataIndex': 'consent_type',
                    'visible': true,
                    'className': null
                }, {
                    'id': 6,
                    'title': 'Status',
                    'key': 'approval_status',
                    'visible': true,
                    'dataIndex': 'approval_status',
                    'className': null
                },{
                    'id': 4,
                    'title': 'rejected reason',
                    'key': 'reject_reason',
                    'dataIndex': 'reject_reason',
                    'visible': true,
                    'className': null
                },                
                {
                    'id': 6,
                    'title': 'Counsellor Submitted ?',
                    'key': 'is_counsellor_submitted',
                    'dataIndex': 'is_counsellor_submitted',
                    'visible': true,
                    'className': null
                },{
                    'id': 4,
                    'title': 'General price (Rs.)',
                    'key': 'general_price',
                    'dataIndex': 'general_price',
                    'visible': true,
                    'className': null
                },{
                    'id': 4,
                    'title': 'price (Rs.)',
                    'key': 'price',
                    'dataIndex': 'price',
                    'visible': true,
                    'className': null
                },{
                    'id': 7,
                    'title': 'Counsellor',
                    'key': 'counsellor',
                    'dataIndex': 'counsellor',
                    'visible': true,
                    'className': null
                },{
                    'id': 4,
                    'title': 'Nurse',
                    'key': 'nurse',
                    'dataIndex': 'nurse',
                    'visible': true,
                    'className': null
                },

            ],
            all_task_body:[],
            loadding:false,
            constentlistHead:[
                {
                    "key": 'consent_id',
                    'text': 'Consent ID'
                },
                {
                    "key": 'ip_no',
                    'text': 'IP Number'
                },
                {
                    "key": 'umr_no',
                    'text': 'UMR'
                },
                {
                    "key": 'patient_name',
                    'text': 'Patient Name'
                }, 
                {
                    "key": 'print',
                    'text': 'Print'
                },  
            ],
            procedures_body:[],
            investigations_head: [
                {
                    'id': 1,
                    'text': 'S.No.',
                    'name': 's_no',
                    'visible': true,
                    'className': 'text-center'
                },
                {
                    'id': 2,
                    'text': 'Investigation Name',
                    'name': 'investigation_name',
                    'visible': true,
                    'className': 'text-center'
                },
                {
                    'id': 3,
                    'text': 'General Price (Rs.)',
                    'name': 'general_price',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 4,
                    'text': 'Price (Rs.)',
                    'name': 'price',
                    'visible': true,
                    'className': null
                }, {
                    'id': 5,
                    'text': 'Status',
                    'name': 'approval_status',
                    'visible': true,
                    'className': null
                }, {
                    'id': 6,
                    'text': 'Declined Reason',
                    'name': 'reject_reason',
                    'visible': true,
                    'className': null
                }, {
                    'id': 7,
                    'text': 'Created Date',
                    'name': 'created_at',
                    'visible': true,
                    'className': null
                }
            ],
            investigations_body: [],
            drug_head: [
                {
                    'id': 1,
                    'text': 'S.No.',
                    'name': 's_no',
                    'visible': true,
                    'className': 'text-center'
                },
                {
                    'id': 2,
                    'text': 'Drug Name',
                    'name': 'drug_name',
                    'visible': true,
                    'className': 'text-center'
                }, {
                    'id': 3,
                    'text': 'Quantity',
                    'name': 'quantity',
                    'visible': true,
                    'className': null
                }, {
                    'id': 3,
                    'text': 'General Price (Rs.)',
                    'name': 'drug_price',
                    'visible': true,
                    'className': null
                }, {
                    'id': 3,
                    'text': 'Price (Rs.)',
                    'name': 'price',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 4,
                    'text': 'Status',
                    'name': 'approval_status',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 5,
                    'text': 'Declined Reason',
                    'name': 'reject_reason',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 6,
                    'text': 'Created Date',
                    'name': 'created_at',
                    'visible': true,
                    'className': null
                }
            ],
            durg_body: [],
            procedures_head: [
                {
                    'id': 1,
                    'text': 'S.No.',
                    'name': 's_no',
                    'visible': true,
                    'className': 'text-center'
                },
                {
                    'id': 2,
                    'text': 'Procedures Name',
                    'name': 'procedure_name',
                    'visible': true,
                    'className': 'text-center'
                },
                {
                    'id': 3,
                    'text': 'General Price (Rs.)',
                    'name': 'general_price',
                    'visible': true,
                    'className': null
                }, {
                    'id': 4,
                    'text': 'Price (Rs.)',
                    'name': 'price',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 5,
                    'text': 'Status',
                    'name': 'approval_status',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 6,
                    'text': 'Declined Reason',
                    'name': 'reject_reason',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 7,
                    'text': 'Created Date',
                    'name': 'created_at',
                    'visible': true,
                    'className': null
                }
            ],
            viewModal:false,
            patient_name:'',
            patient_details:[],
            consent_details:[],
            investigations_body_print:[],
            durg_body_print:[],
            procedures_body_print:[],
            inputValue: '',
            nmeExtraAmount: 5000,
            'tablebody': [],
            'tableshead': [],
        }
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.carousel = React.createRef();
    }


    componentDidMount = async() => {
        // let nmeExtra = this.props.counselling_details.nme_extra_amount;
        // this.setState({nmeExtraAmount: nmeExtra})
        await this.loadPage();
        let { slug } = this.props.match.params;
        let nmeExtra;
        if (slug === "financial-counselling") {
            hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema:[],los:null, status: true } })
            // nmeExtra = this.props.counselling_details.nme_extra_amount;
            // this.setState({nmeExtraAmount: nmeExtra})
        } 
        else if (this.props.counselling_details && this.props.counselling_details.nme_extra_amount) {
            console.error("Counselling details or nme_extra_amount is null.", this.state);
        nmeExtra = this.props.counselling_details.nme_extra_amount;
        this.setState({nmeExtraAmount: nmeExtra})
        } else {
        console.error("Counselling details or nme_extra_amount is null.");
        }
        $('footer').hide();
        hideInEXStore.subscribe(
            () => {
                this.loadingState(hideInEXStore.getState())
            });
        this.getroomNamesonImages();
        this.getroomImages();
        this.loadingState(hideInEXStore.getState());
        let tokenData = JSON.parse(Storage.get('current_token'));
        if (tokenData && tokenData['form_type_id']  == 2) {
            this.setState({hide:true,hiderooms: false });
        } 
        else {
            this.setState({ hiderooms: false });
        }
    }

    componentWillUnmount() {
        this.setState({
            visible: false,
            formData: []
        });
    }

    getroomNamesonImages() {
        let { getroomNamesonImages } = networkList;
        postService(getroomNamesonImages, 'GET', {}).then(res => {
            if (res['status']) {
                const uniqueRooms = [];
                const seenNames = new Set();
                for (const element of res['data']) {
                if (!seenNames.has(element.id)) {
                    seenNames.add(element.id);
                    uniqueRooms.push(element);
                }
                }
                this.setState((state) => ({ 'roomTabs': uniqueRooms }));
                // this.setState((state) => ({ 'roomTabs': res['data'] }));
            } else {
                this.setState((state) => ({ 'roomTabs': [] }));
            }
        });
    }
    getroomImages() {
        let { getallroomImages } = networkList;
        postService(getallroomImages, 'GET', {}).then(res => {
            if (res.status) {
                let arr = [];
                let { roomTabs } = this.state
                if (roomTabs !== '' && roomTabs !== undefined && roomTabs !== null && roomTabs.length > 0) {
                    let val = parseInt(roomTabs[0]['id']);
                    res['data'].forEach((res, key) => {
                        if (res.room_id == val) {
                            arr.push(res.room_path);
                        }
                    })
                    this.setState((state) => ({ 'roomImages': res['data'], 'rooms': arr }))
                } else {
                    this.setState((state) => ({ 'roomImages': res['data'] }))
                }
                this.setState((state) => ({ 'roomImages': res['data'] }))
            } else {
                this.setState((state) => ({ 'roomImages': [] }))
            }
        })
    }

    setModal1Visible(modal1Visible) {
        this.setState({ modal1Visible });
    }

    setModal2Visible(modal2Visible) {

        this.setState({ modal2Visible });
    }
  
    setModal3Visible(modal3Visible) {
        let { slug } = this.props.match.params;
        const {nmePopupSchema} = this.state;
        if (slug === "finanical-counselling") {
            nmePopupSchema.forEach((subTable, key) => {
                subTable.Specification.add_more = true;
                subTable.Specification.table_body.length = 0;
            });

            nmePopupSchema.forEach((subTable, key) => {
                const table_body = subTable.Specification.table_body;

                nmePopupSchema.forEach((item, skey) => {
                    let obj = {
                        "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? 
                            (JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds']))) : [],
                        id: skey + 1,
                        input_feild: [],
                        text: "Highend",
                        'key_word': 'add_more',
                        type: "text"
                    };

                    obj['feilds'].forEach((feild, key) => {
                        obj['feilds'][key]['id'] = null;
                        obj['feilds'][key]['value'] = null;
                        obj['feilds'][key]['text'] = null;
                    });

                    // obj['feilds'].forEach((feild, key) => {
                    //     obj['feilds'][key]['id'] = skey + 1;
                    //     if (feild.name === "unit") {
                    //         obj['feilds'][key]['value'] = item.unitname;
                    //         obj['feilds'][key]['text'] = item.unitname;
                    //     }
                    //     if (feild.name === "department") {
                    //         obj['feilds'][key]['value'] = item.dept_cd;
                    //         obj['feilds'][key]['text'] = item.dept_cd;
                    //     }
                    //     if (feild.name === "description") {
                    //         obj['feilds'][key]['value'] = item.description;
                    //         obj['feilds'][key]['text'] = item.description;
                    //     }
                    //     if (feild.name === "tariff") {
                    //         obj['feilds'][key]['value'] = item.name;
                    //         obj['feilds'][key]['text'] = item.name;
                    //     }
                    //     if (feild.name === "rate") {
                    //         obj['feilds'][key]['value'] = item.rate;
                    //         obj['feilds'][key]['text'] = item.rate;
                    //     }
                    //     if (feild.name === "amount") {
                    //         obj['feilds'][key]['value'] = item.rate * los;
                    //         obj['feilds'][key]['text'] = item.rate * los;
                    //     }
                    // });
                    obj['feilds'].forEach((feild, key) => {
                        obj['feilds'][key]['id'] = skey + 1;
                        if (feild.name === "unit") {
                            obj['feilds'][key]['value'] = null;
                            obj['feilds'][key]['text'] = null;
                        }
                        if (feild.name === "department") {
                            obj['feilds'][key]['value'] = null;
                            obj['feilds'][key]['text'] = null;
                        }
                        if (feild.name === "description") {
                            obj['feilds'][key]['value'] = null;
                            obj['feilds'][key]['text'] = null;
                        }
                        if (feild.name === "tariff") {
                            obj['feilds'][key]['value'] = null;
                            obj['feilds'][key]['text'] = null;
                        }
                        if (feild.name === "rate") {
                            obj['feilds'][key]['value'] = null;
                            obj['feilds'][key]['text'] = null;
                        }
                        if (feild.name === "amount") {
                            obj['feilds'][key]['value'] = null;
                            obj['feilds'][key]['text'] = null;
                        }
                    });

                    subTable['Specification']['table_body'].push(obj);
                });
            });
            //hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema, status: false } })
        }
        this.setState({ modal3Visible });
        // let { slug } = this.props.match.params;
        // if(slug === "finanical-counselling" || slug === "recounselling") {
        const rootStore = rootReduxStore.getState();
        const losStore = losReduxStore.getState();
        const specalityStore = specialityReduxStore.getState();
        const los = losStore.data;  
        // const {nmePopupSchema} = this.state;
    
            this.setState({ loading: true });
            let user_data = ''
            if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
             user_data = JSON.parse(localStorage.getItem('user_data'))
            }
            if (rootStore.data && rootStore.data[0] && rootStore.data[0].tariff_mapped) {
                this.setState({ modal3Visible });
                const tariff =  rootStore.data[0].tariff_mapped;
                const speciality = specalityStore.data
                const requestData = {
                data: {"unit_id": user_data['unitid'] ? user_data['unitid'] : '',"dept_cd": speciality ,"tariff_id": tariff}
                };
            postService('getMasterNmeList', 'POST', requestData).then(res => {
                if (res.status) {
                    const exclude_data_recounselling = res.data; // Assuming responseData is the data you provided

                        if (exclude_data_recounselling && exclude_data_recounselling.length > 0) {
                            nmePopupSchema.forEach((subTable, key) => {
                                subTable.Specification.add_more = true;
                                subTable.Specification.table_body.length = 0;
                            });

                            nmePopupSchema.forEach((subTable, key) => {
                                const table_body = subTable.Specification.table_body;

                                exclude_data_recounselling.forEach((item, skey) => {
                                    let obj = {
                                        "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? 
                                            (JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds']))) : [],
                                        id: skey + 1,
                                        input_feild: [],
                                        text: "Highend",
                                        'key_word': 'add_more',
                                        type: "text"
                                    };

                                    obj['feilds'].forEach((feild, key) => {
                                        obj['feilds'][key]['id'] = null;
                                        obj['feilds'][key]['value'] = null;
                                        obj['feilds'][key]['text'] = null;
                                    });

                                    obj['feilds'].forEach((feild, key) => {
                                        obj['feilds'][key]['id'] = skey + 1;
                                        if (feild.name === "nme_id") {
                                            obj['feilds'][key]['value'] = item.id;
                                            obj['feilds'][key]['text'] = item.id;
                                        }
                                        if (feild.name === "unit") {
                                            obj['feilds'][key]['value'] = item.unitname;
                                            obj['feilds'][key]['text'] = item.unitname;
                                        }
                                        if (feild.name === "department") {
                                            obj['feilds'][key]['value'] = item.dept_cd;
                                            obj['feilds'][key]['text'] = item.dept_cd;
                                        }
                                        if (feild.name === "description") {
                                            obj['feilds'][key]['value'] = item.description;
                                            obj['feilds'][key]['text'] = item.description;
                                        }
                                        if (feild.name === "tariff") {
                                            obj['feilds'][key]['value'] = item.name;
                                            obj['feilds'][key]['text'] = item.name;
                                        }
                                        if (feild.name === "rate") {
                                            obj['feilds'][key]['value'] = item.rate;
                                            obj['feilds'][key]['text'] = item.rate;
                                        }
                                        if (feild.name === "amount") {
                                            obj['feilds'][key]['value'] = item.rate * los;
                                            obj['feilds'][key]['text'] = item.rate * los;
                                        }
                                    });

                                    subTable['Specification']['table_body'].push(obj);
                                });
                            });
                            //hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema, status: false } })
                        }else if (slug === "finanical-counselling") {
                            nmePopupSchema.forEach((subTable, key) => {
                                subTable.Specification.add_more = true;
                                subTable.Specification.table_body.length = 0;
                            });

                            nmePopupSchema.forEach((subTable, key) => {
                                const table_body = subTable.Specification.table_body;

                                exclude_data_recounselling.forEach((item, skey) => {
                                    let obj = {
                                        "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? 
                                            (JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds']))) : [],
                                        id: skey + 1,
                                        input_feild: [],
                                        text: "Highend",
                                        'key_word': 'add_more',
                                        type: "text"
                                    };

                                    obj['feilds'].forEach((feild, key) => {
                                        obj['feilds'][key]['id'] = null;
                                        obj['feilds'][key]['value'] = null;
                                        obj['feilds'][key]['text'] = null;
                                    });

                                    // obj['feilds'].forEach((feild, key) => {
                                    //     obj['feilds'][key]['id'] = skey + 1;
                                    //     if (feild.name === "unit") {
                                    //         obj['feilds'][key]['value'] = item.unitname;
                                    //         obj['feilds'][key]['text'] = item.unitname;
                                    //     }
                                    //     if (feild.name === "department") {
                                    //         obj['feilds'][key]['value'] = item.dept_cd;
                                    //         obj['feilds'][key]['text'] = item.dept_cd;
                                    //     }
                                    //     if (feild.name === "description") {
                                    //         obj['feilds'][key]['value'] = item.description;
                                    //         obj['feilds'][key]['text'] = item.description;
                                    //     }
                                    //     if (feild.name === "tariff") {
                                    //         obj['feilds'][key]['value'] = item.name;
                                    //         obj['feilds'][key]['text'] = item.name;
                                    //     }
                                    //     if (feild.name === "rate") {
                                    //         obj['feilds'][key]['value'] = item.rate;
                                    //         obj['feilds'][key]['text'] = item.rate;
                                    //     }
                                    //     if (feild.name === "amount") {
                                    //         obj['feilds'][key]['value'] = item.rate * los;
                                    //         obj['feilds'][key]['text'] = item.rate * los;
                                    //     }
                                    // });
                                    obj['feilds'].forEach((feild, key) => {
                                        obj['feilds'][key]['id'] = skey + 1;
                                        if (feild.name === "unit") {
                                            obj['feilds'][key]['value'] = null;
                                            obj['feilds'][key]['text'] = null;
                                        }
                                        if (feild.name === "department") {
                                            obj['feilds'][key]['value'] = null;
                                            obj['feilds'][key]['text'] = null;
                                        }
                                        if (feild.name === "description") {
                                            obj['feilds'][key]['value'] = null;
                                            obj['feilds'][key]['text'] = null;
                                        }
                                        if (feild.name === "tariff") {
                                            obj['feilds'][key]['value'] = null;
                                            obj['feilds'][key]['text'] = null;
                                        }
                                        if (feild.name === "rate") {
                                            obj['feilds'][key]['value'] = null;
                                            obj['feilds'][key]['text'] = null;
                                        }
                                        if (feild.name === "amount") {
                                            obj['feilds'][key]['value'] = null;
                                            obj['feilds'][key]['text'] = null;
                                        }
                                    });

                                    subTable['Specification']['table_body'].push(obj);
                                });
                            });
                            //hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema, status: false } })
                        }
                         else {
                            nmePopupSchema.forEach((subTable, key) => {
                                subTable.Specification.add_more = true;
                                const table_body = subTable.Specification.table_body;

                                if (table_body.length > 0) {
                                    table_body.forEach((feild, table_key) => {
                                        if (table_key === 0) {
                                            const row = feild.feilds;
                                            row.forEach((sub_feild, sub_table_key) => {
                                                if (sub_feild.name === 'nmevlaue') {
                                                    nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                    nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                }
                                            });
                                        } else {
                                            if (feild.key_word === 'add_more') {
                                                nmePopupSchema[key].Specification.table_body.splice(table_key, 2);
                                            }
                                        }
                                    });
                                }
                            });
                        }
                    
                    if (res.data && res.data.length>0) {
                        this.setState({ nmePopupSchema: nmePopupSchema }); 
                    }
                    // else{
                    //     this.setState({ nmePopupSchema: [] }); 
                    // }
                } else {
                    this.setState({ loadding: false })
                    Modal.error({
                        title: 'Failure',
                        content: res.message ? res.message : 'Oops! something is wrong. Please try again.',
                    })
                }
            })
        }
        // else{
        //     this.setState({ loadding: false })
        //     if(slug === "finanical-counselling" || slug === "recounselling") {
        //             Modal.error({
        //                 title: 'Failure',
        //                 content: 'Please select TPA Name and Length Of Stay',
        //             })
        //         }
        // }
    // }else{
    //     this.setState({ modal3Visible });
    // }
    }

    loadPage = () => {
        try {
            let This = this;
            let userData = localStorage.getItem('user_data');
            let { activePage, doctor_id, department_name, payer_type, bill_value, nurse_station_code, ward_type } = this.state;
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            let {ip_no, umr_no} = this.props.basic_info;
            console.log("this.props.basic",this.props.basic_info);
            let tableHead = [];
            tableHead = [
                {
                    "key":'umr_no',
                    'label':'UMR:'
                },
                {
                    "key":'ip_no',
                    'label':'IP Number:'
                },
                {
                    "key":'patient_name',
                    'label':'Patient Name:'
                },
                {
                    "key":'patient_phno',
                    'label':'Patient Phone:'
                },
                {
                    "key":'patient_age',
                    "label":'Age:'
                },
                {
                    "key":'patient_gender',
                    'label':'Gender:'
                },
                {
                    "key":'ref_doctor_name',
                    'label':'Ref Doctor Name:'
                },
                {
                    "key":'is_admission_advised',
                    'label':'Is Admission Advised:'
                },
                {
                    "key":'estimated_admission_date',
                    'label':'Estimated Date Of Admission:'
                },
                {
                    "key":'remarks',
                    'label':'Remarks:'
                },
                {
                    "key":'created_at',
                    'label':'Advised Date:'
                },
                {
                    "key":'updated_at',
                    'label':'Modified Date:'
                },
                // {
                //     "key":'is_counselling_done',
                //     'label':'Is Counselling Done'
                // },
                {
                    "key":'unitname',
                    'label': 'Unit Name:'
                },
                {
                    "key":'los_wards',
                    'label': 'LOS Wards:'
                },
                {
                    "key":'los_icu',
                    'label': 'LOS ICU:'
                },
                {
                    "key":'op_investigations',
                    'label': 'OP Investigations:'
                },
                {
                    "key":'op_procedures',
                    'label': 'OP Procedures:'
                },
                {
                    "key":'implant_cost',
                    'label': 'Implant Cost:'
                },
                {
                    "key":'total_estimated_cost',
                    'label': 'Total Estimated Cost:'
                },
                {
                    "key":'surgeries',
                    'label': 'Surgeries:'
                },
                {
                    "key":'professional_fees',
                    'label': 'Professional Fees:'
                },
                {
                    "key":'department_type',
                    'label': 'Care Management'
                }
            ]
            let ward_type_value = ''
            if(ward_type){
                if(ward_type.length>1){
                    ward_type_value = 'all'
                }else{
                    ward_type_value = ward_type[0]
                }
            }else{
                ward_type_value = null
            }
            this.setState((state) => ({ downloadStatus: 0, tablebody: [], tableTitle: 'Admissions Advised', tableshead: tableHead, loadding: true, filename: 'Admission-Advised-Report.csv' }), () => {
                postService('getAdmissionAdvises', 'POST', {
                    "data": {
                        "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                        "search_key": "",
                        "from": '',
                        "to": '',
                        "umr_no":umr_no ? umr_no : null,
                        "ip_no":ip_no,
                        "advicesFlag": 1
                    }
                }).then(res => {
                    console.log('tat report:', res);
                    // console.log('data res:', data)
                    if (res.status) {
                        res.data.map((data, key) => {
                            Object.keys(data).map((dataKey) => {
                                if (dataKey === 'admission_date') {
                                    res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm') : null
                                }
                                if (dataKey === 'latest_counselled_date') {
                                    res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm') : null
                                }
                                if(dataKey === 'department_type'){
                                    res.data[key][dataKey] = res.data[key][dataKey] === 'medical_department' ? 'Medical' : 'Surgical'
                                }



                            })
                        })
                        this.setState((state) => ({ totalItemsCount: res.total_items, tablebody: res.data, loadding: false }));
                        // enable downloadbtn after 2sec
                        setTimeout(function () {
                            This.setState((state) => ({ downloadStatus: 1 }))
                        }, 2000);
                    } else {
                        if (res === 401) {

                        } else {
                            Modal.error({
                                title: 'Failure',
                                content: "Oops! something went wrong... Please try again.",
                            });
                        }
                    }
                });
            });
        } catch (error) {
            console.log(error);
        }
    }

    setModal4Visible(modal4Visible) {
        this.setState({ modal4Visible });
    }
    includesOK() {
        this.setModal1Visible(false);
        this.setModal2Visible(true)
    }
    excludesOK() {
        let { payment_mode } = this.props;
        this.setModal2Visible(false);
    }
    nmeOK() {
        this.setModal3Visible(false);
    }
    async loadingState(data) {   
        console.log('LOADINGDATA', data);     
        let { nmePopupSchema } = this.state;
        let { active_tab, payment_mode, includesSchema,counselling_details,basic_info } = this.props;
        // const result = await this.getNmeService();
        let value 
        if(data['hide']!==undefined){
            value= data && data['hide'] ? data['hide'] : false;  
        }else{
            value=true
        }
        this.setState({ hide: value });

        //    recounselling  exclude
        let exclude_data_recounselling = data['exclude_data_recounselling'] ? data['exclude_data_recounselling'] : [];
        if (data['exclude_data_recounselling']) {
            if (exclude_data_recounselling.length > 0) {
                excludes_schema['feilds'].map((subTable, key) => {
                    excludes_schema['feilds'][key].Specification.add_more = true;
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        excludes_schema['feilds'][key].Specification.table_body.length = 0;
                    })
                });
                excludes_schema['feilds'].map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    exclude_data_recounselling.map((item, skey) => {
                        
                        let obj = {
                            "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? (JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds']))) : [],
                            id: skey + 1,
                            input_feild: [],
                            text: "Highend",
                            'key_word': 'add_more',
                            type: "text"

                        }
                        obj['feilds'].map((feild, key) => {
                            obj['feilds'][key]['id'] = null;
                            obj['feilds'][key]['value'] = null;
                            obj['feilds'][key]['text'] = null;
                        })
                        obj['feilds'].map((feild, key) => {
                            obj['feilds'][key]['id'] = skey + 1;
                            if (feild.name === "excludes_service_id") {
                                obj['feilds'][key]['service'] = item.service_name
                                obj['feilds'][key]['text'] = item.service_name;
                                obj['feilds'][key]['value'] = item.service;
                                obj['feilds'][key]['package_id'] =item.package_id;
                            }
                            if (feild.name === "qty") {
                                obj['feilds'][key]['value'] = item.qty;
                                obj['feilds'][key]['text'] = item.qty;
                            }
                            if (feild.name === "rate") {
                                obj['feilds'][key]['value'] = item.rate;
                                obj['feilds'][key]['text'] = item.rate;
                            }
                            if (feild.name === "amount") {
                                obj['feilds'][key]['value'] = parseFloat(item.qty || 0) * parseFloat(item.rate || 0);
                                obj['feilds'][key]['text'] = parseFloat(item.qty || 0) * parseFloat(item.rate || 0);
                            }
                            // if (feild.name === "action") {
                            //     obj['feilds'][key]['element'] = 'text';
                            // }

                        })
                        subTable['Specification']['table_body'].push(obj);
                        // }

                    })
                });


            } else {
                excludes_schema['feilds'].map((subTable, key) => {
                    excludes_schema['feilds'][key].Specification.add_more = true;
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (table_body.length > 0) {
                            if (table_key === 0) {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    if (sub_feild.name === 'excludes_service_id') {
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                        // excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    }
                                })
                            } else {
                                if (feild.key_word === 'add_more') {
                                    excludes_schema['feilds'][key].Specification.table_body.splice(table_key, 2)
                                }

                            }
                        }
                    })
                });
            }
        }

        let nem_data_view = data['nme_view_data'] ? data['nme_view_data'] : [];
                console.log('nem_data_view::::', nem_data_view);
        let flag = data['status'] ? 1 : 0;
        let page = data['page'] ? data['page'] : [];
        // switch (slug) {
        //     case 'view-finanical-counselling': {
        if (page === 'view-finanical-counselling') {
            // view exclude
            let exclude_data = data['excludesData'] ? data['excludesData'] : [];
            if (data['excludesData']) {
                if (exclude_data.length > 0) {
                    excludes_schema['feilds'].map((subTable, key) => {
                        excludes_schema['feilds'][key].Specification.add_more = true;
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            if (table_body.length > 0) {
                                excludes_schema['feilds'][key].Specification.table_body.length = 0;
                            }
                        })
                    });

                    excludes_schema['feilds'].map((subTable, key) => {
                        let table_body = subTable.Specification.table_body;
                        exclude_data.map((item, skey) => {
                            let obj = {
                                "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? (JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds']))) : [],
                                id: skey + 1,
                                input_feild: [],
                                text: "Highend",
                                'key_word': 'add_more',
                                type: "text"

                            }
                            obj['feilds'].map((feild, key) => {
                                obj['feilds'][key]['id'] = null;
                                obj['feilds'][key]['value'] = null;
                                obj['feilds'][key]['text'] = null;
                            })
                            obj['feilds'].map((feild, key) => {
                                obj['feilds'][key]['id'] = skey + 1;
                                if (feild.name === "excludes_service_id") {
                                    obj['feilds'][key]['text'] = item.service_name;
                                    obj['feilds'][key]['value'] = item.service;
                                    obj['feilds'][key]['disable'] = true;
                                }
                                if (feild.name === "qty") {
                                    obj['feilds'][key]['value'] = item.qty;
                                    obj['feilds'][key]['text'] = item.qty;
                                    obj['feilds'][key]['disable'] = true;
                                }
                                if (feild.name === "rate") {
                                    obj['feilds'][key]['value'] = item.rate;
                                    obj['feilds'][key]['text'] = item.rate;
                                    obj['feilds'][key]['disable'] = true;
                                }
                                if (feild.name === "amount") {
                                    obj['feilds'][key]['value'] = parseFloat(item.qty || 0) * parseFloat(item.rate || 0);
                                    obj['feilds'][key]['text'] = parseFloat(item.qty || 0) * parseFloat(item.rate || 0);
                                    obj['feilds'][key]['disable'] = true;
                                }
                                if (feild.name === "action") {
                                    obj['feilds'][key]['element'] = 'text';
                                }

                            })
                            subTable['Specification']['table_body'].push(obj);
                            // }

                        })
                    });

                    // excludesTableStore.dispatch({ type: 'options_data', 'data': excludes_schema });
                }else{
                    excludes_schema['feilds'].map((subTable, key) => {
                        excludes_schema['feilds'][key].Specification.add_more = true;
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            if (table_body.length > 0) {
                                excludes_schema['feilds'][key].Specification.table_body.length = 0;
                            }
                        })
                    }); 
                }
            } else {
                excludes_schema['feilds'].map((subTable, key) => {
                    excludes_schema['feilds'][key].Specification.add_more = true;
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (table_body.length > 0) {
                            excludes_schema['feilds'][key].Specification.table_body.length = 0;
                        }
                    })
                });
            }
            if (flag === 1) {
                if (data['nme_view_data']) {
                    if (nem_data_view.length > 0) {
                        nmePopupSchema.map((subTable, key) => {
                            let table_body = subTable.Specification.table_body;
                            nmePopupSchema[key].Specification.table_body.length=0
                            this.setState({ nmePopupSchema: nmePopupSchema });

                        })
                        nmePopupSchema.map((subTable, key) => {
                            let table_body = subTable.Specification.table_body;
                            nmePopupSchema[key].Specification.table_body.length=0
                            nem_data_view.map((item, skey) => {
                                console.log('IRE::::', item, this.state, this.props);
                                    let obj = {
                                        "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? (JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds']))) : [],
                                        id: skey + 1,
                                        input_feild: [],
                                        text: "Highend",
                                        'key_word': 'add_more',
                                        type: "text"

                                    }
                                    obj['feilds'].map((feild, key) => {
                                        obj['feilds'][key]['id'] = null;
                                        obj['feilds'][key]['value'] = null;
                                        obj['feilds'][key]['text'] = null;
                                    })
                                    obj['feilds'].map((feild, key) => {
                                        obj['feilds'][key]['id'] = skey + 1;
                                        if (feild.name === "unit") {
                                            obj['feilds'][key]['text'] = item.unitname;
                                            obj['feilds'][key]['value'] = item.unitname;
                                            obj['feilds'][key]['disable'] = true;
                                        }
                                        if (feild.name === "department") {
                                            obj['feilds'][key]['title'] = item.nme_name;
                                            obj['feilds'][key]['value'] = item.nme_name;
                                            obj['feilds'][key]['disable'] = true;
                                        }
                                        if (feild.name === "description") {
                                            obj['feilds'][key]['title'] = item.nme_description;
                                            obj['feilds'][key]['value'] = item.nme_description;
                                            obj['feilds'][key]['disable'] = true;
                                        }
                                        if (feild.name === "tariff") {
                                            obj['feilds'][key]['title'] = item.tariff_name;
                                            obj['feilds'][key]['value'] = item.tariff_name;
                                            obj['feilds'][key]['disable'] = true;
                                        }
                                        if (feild.name === "rate") {
                                            obj['feilds'][key]['value'] = item.nme_rate;
                                            obj['feilds'][key]['text'] = item.nme_rate;
                                            obj['feilds'][key]['disable'] = true;

                                        }
                                        if (feild.name === "amount") {
                                            obj['feilds'][key]['value'] = item.nme_amount;
                                            obj['feilds'][key]['text'] = item.nme_amount;
                                            obj['feilds'][key]['disable'] = true;

                                        }
                                       

                                    })
                                    subTable['Specification']['table_body'].push(obj);

                                this.setState({ nmePopupSchema: nmePopupSchema });
                            })
                        })
                    }
                    else {
                        nmePopupSchema.map((subTable, key) => {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                if (table_key === 0) {
                                    let row = feild.feilds;
                                    row.map((sub_feild, sub_table_key) => {
                                        if (sub_feild.name === "nmename") {
                                            nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                            nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null
                                            nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true


                                        }
                                        if (sub_feild.name === "description") {
                                            nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["title"] = null
                                            nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null
                                        }
                                        if (sub_feild.name === "amount") {
                                            nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                            nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null

                                        }

                                    })
                                } else {
                                    if (feild.key_word === 'add_more') {
                                        nmePopupSchema[key].Specification.table_body.splice(table_key, 2)

                                    }
                                }
                                this.setState({ nmePopupSchema: nmePopupSchema });
                            })

                        })
                    }
                }

                hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema, status: false } })

            }
            // end exclude
        }
        if (page === 'finanical-counselling') {
            if (flag === 1) {

                // nmePopupSchema.map((subTable, key) => {
                //     let table_body = subTable;
                //     nmePopupSchema[key].Specification.table_body.length=0
                //     this.setState({ nmePopupSchema: nmePopupSchema });

                // })
                // const { getMasterNMEs,  getMasterNmeList,} = networkList;
                // const counsellingDetails = this.props.counselling_details;
                // if (counsellingDetails && counsellingDetails.tariff_mapped) {
                //     const speciality = this.props.basic_info.token_doctor_speciality;
                //     const tariff = counsellingDetails.tariff_mapped;
                //     let user_data;
                //     if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
                //         user_data = JSON.parse(localStorage.getItem('user_data'))
                //     }
                //                 const requestData = {
                //                     data: {"unit_id": user_data['unitid'] ? user_data['unitid'] : '',"dept_cd":'ENDOCRINOLOGY' ,"tariff_id": '0'}
                //                 };
                //                 postService(getMasterNMEs, 'GET', null).then(res => {
                        
                //                     if (res) {
                //                         nmePopupSchema.map((subTable, key) => {
                //                             let table_body = subTable.Specification.table_body;
                //                             nmePopupSchema[key].Specification.table_body.length=0
                //                             res.data.map((item, skey) => {
                                            
                //                                     let obj = {
                //                                         "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? (JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds']))) : [],
                //                                         id: skey + 1,
                //                                         input_feild: [],
                //                                         text: "Highend",
                //                                         'key_word': 'add_more',
                //                                         type: "text"

                //                                     }
                //                                     obj['feilds'].map((feild, key) => {
                //                                         obj['feilds'][key]['id'] = null;
                //                                         obj['feilds'][key]['value'] = null;
                //                                         obj['feilds'][key]['text'] = null;
                //                                     })
                //                                     obj['feilds'].map((feild, key) => {
                //                                         obj['feilds'][key]['id'] = skey + 1;
                //                                         if (feild.name === "unit") {
                //                                             obj['feilds'][key]['text'] = item.unit_id;
                //                                             obj['feilds'][key]['value'] = item.id;
                //                                             obj['feilds'][key]['disable'] = true;
                //                                         }
                //                                         // if (feild.name === "department") {
                //                                         //     obj['feilds'][key]['title'] = item.dept_cd;
                //                                         //     obj['feilds'][key]['value'] = item.dept_cd;
                //                                         //     obj['feilds'][key]['disable'] = true;
                //                                         // }
                //                                         // if (feild.name === "description") {
                //                                         //     obj['feilds'][key]['title'] = item.description;
                //                                         //     obj['feilds'][key]['value'] = item.description;
                //                                         //     obj['feilds'][key]['disable'] = true;
                //                                         // }
                //                                         // if (feild.name === "tariff") {
                //                                         //     obj['feilds'][key]['title'] = item.name;
                //                                         //     obj['feilds'][key]['value'] = item.name;
                //                                         //     obj['feilds'][key]['disable'] = true;
                //                                         // }
                //                                         // if (feild.name === "rate") {
                //                                         //     obj['feilds'][key]['value'] =item.rate?item.rate:0;
                //                                         //     obj['feilds'][key]['text'] =item.rate?item.rate:0;
                //                                         //     obj['feilds'][key]['disable'] = false;

                //                                         // }
                //                                         // if (feild.name === "amount") {
                //                                         //     obj['feilds'][key]['value'] =item.rate?item.rate:0;
                //                                         //     obj['feilds'][key]['text'] =item.rate?item.rate:0;
                //                                         //     obj['feilds'][key]['disable'] = false;

                //                                         // }
                //                                         if (feild.name === "department") {
                //                                             obj['feilds'][key]['title'] = item.nme_name;
                //                                             obj['feilds'][key]['value'] = item.nme_name;
                //                                             obj['feilds'][key]['disable'] = true;
                //                                         }
                //                                         if (feild.name === "description") {
                //                                             obj['feilds'][key]['title'] = item.nme_description;
                //                                             obj['feilds'][key]['value'] = item.nme_description;
                //                                             obj['feilds'][key]['disable'] = true;
                //                                         }
                //                                         if (feild.name === "tariff") {
                //                                             obj['feilds'][key]['title'] = item.nme_tariff;
                //                                             obj['feilds'][key]['value'] = item.nme_tariff;
                //                                             obj['feilds'][key]['disable'] = true;
                //                                         }
                //                                         if (feild.name === "rate") {
                //                                             obj['feilds'][key]['value'] = item.nme_rate;
                //                                             obj['feilds'][key]['text'] = item.nme_rate;
                
                //                                         }
                //                                         if (feild.name === "amount") {
                //                                             obj['feilds'][key]['value'] = item.nme_amount;
                //                                             obj['feilds'][key]['text'] = item.nme_amount;
                
                //                                         }
                                                    

                //                                     })
                //                                     subTable['Specification']['table_body'].push(obj);

                //                                     this.setState({ nmePopupSchema: nmePopupSchema });
                //                             })
                //                         })
                //                         hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema, status: false } })
                //                     }
                //                 });

                //             }
                //             else{

                //             }
                /////////////////////////
                let { slug } = this.props.match.params;
                const rootStore = rootReduxStore.getState();
                const losStore = losReduxStore.getState();
                let { active_tab, payment_mode, includesSchema,counselling_details,basic_info } = this.props;
        const specalityStore = specialityReduxStore.getState();
        const los = data['los']?data['los']:null;  
        if(los!==null ){
            const {nmePopupSchema} = this.state;
        this.setState({ loading: true });
        let user_data = ''
        if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
         user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        if (rootStore.data && rootStore.data[0] && rootStore.data[0].tariff_mapped) {
            //this.setState({ modal3Visible });
            const tariff =  rootStore.data[0].tariff_mapped;
            const speciality = specalityStore.data
            const requestData = {
            data: {"unit_id": user_data['unitid'] ? user_data['unitid'] : '',"dept_cd": speciality ,"tariff_id": tariff}
            };
        postService('getMasterNmeList', 'POST', requestData).then(res => {
            if (res.status) {
                const exclude_data_recounselling = res.data; // Assuming responseData is the data you provided

                    if (exclude_data_recounselling && exclude_data_recounselling.length > 0) {
                        nmePopupSchema.forEach((subTable, key) => {
                            subTable.Specification.add_more = true;
                            subTable.Specification.table_body.length = 0;
                        });

                        nmePopupSchema.forEach((subTable, key) => {
                            const table_body = subTable.Specification.table_body;

                            exclude_data_recounselling.forEach((item, skey) => {
                                let obj = {
                                    "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? 
                                        (JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds']))) : [],
                                    id: skey + 1,
                                    input_feild: [],
                                    text: "Highend",
                                    'key_word': 'add_more',
                                    type: "text"
                                };

                                obj['feilds'].forEach((feild, key) => {
                                    obj['feilds'][key]['id'] = null;
                                    obj['feilds'][key]['value'] = null;
                                    obj['feilds'][key]['text'] = null;
                                });

                                obj['feilds'].forEach((feild, key) => {
                                    obj['feilds'][key]['id'] = skey + 1;
                                    if (feild.name === "nme_id") {
                                        obj['feilds'][key]['value'] = item.id;
                                        obj['feilds'][key]['text'] = item.id;
                                    }
                                    if (feild.name === "unit") {
                                        obj['feilds'][key]['value'] = item.unitname;
                                        obj['feilds'][key]['text'] = item.unitname;
                                    }
                                    if (feild.name === "department") {
                                        obj['feilds'][key]['value'] = item.dept_cd;
                                        obj['feilds'][key]['text'] = item.dept_cd;
                                    }
                                    if (feild.name === "description") {
                                        obj['feilds'][key]['value'] = item.description;
                                        obj['feilds'][key]['text'] = item.description;
                                    }
                                    if (feild.name === "tariff") {
                                        obj['feilds'][key]['value'] = item.name;
                                        obj['feilds'][key]['text'] = item.name;
                                    }
                                    if (feild.name === "rate") {
                                        obj['feilds'][key]['value'] = item.rate;
                                        obj['feilds'][key]['text'] = item.rate;
                                    }
                                    if (feild.name === "amount") {
                                        obj['feilds'][key]['value'] = item.rate * los;
                                        obj['feilds'][key]['text'] = item.rate * los;
                                    }
                                });

                                subTable['Specification']['table_body'].push(obj);
                            });
                        });
                        
                    } else {
                        nmePopupSchema.forEach((subTable, key) => {
                            subTable.Specification.add_more = true;
                            const table_body = subTable.Specification.table_body;

                            if (table_body.length > 0) {
                                table_body.forEach((feild, table_key) => {
                                    if (table_key === 0) {
                                        const row = feild.feilds;
                                        row.forEach((sub_feild, sub_table_key) => {
                                            if (sub_feild.name === 'nmevlaue') {
                                                nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            }
                                        });
                                    } else {
                                        if (feild.key_word === 'add_more') {
                                            nmePopupSchema[key].Specification.table_body.splice(table_key, 2);
                                        }
                                    }
                                });
                            }
                        });
                    }
                
                if (res['data'] && res['data'].length>0) {                   
                    this.setState({ nmePopupSchema: nmePopupSchema }); 
                }
            } else {
                this.setState({ loadding: false })
                Modal.error({
                    title: 'Failure',
                    content: res.message ? res.message : 'Oops! something is wrong. Please try again.',
                })
            }
            hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema,los:null, status: true } })
        })
     }
    //   hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema,los:null, status: true } })
        }
       
        //else{
        //     this.setState({ loadding: false })
        //     if(slug === "finanical-counselling" || slug === "recounselling") {
        //             Modal.error({
        //                 title: 'Failure',
        //                 content: 'Please select TPA Name and Length Of Stay',
        //             })
        //         }
        // }
                excludes_schema['feilds'].map((subTable, key) => {
                    excludes_schema['feilds'][key].Specification.add_more = true;
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (table_body.length > 0) {
                            excludes_schema['feilds'][key].Specification.table_body.length = 0;
                        }
                    })
                });


                excludes_schema['feilds'].map((subTable, key) => {
                    excludes_schema['feilds'][key].Specification.add_more = true;
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (table_body.length > 0) {
                            if (table_key === 0) {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    if (sub_feild.name === 'excludes_service_id') {
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;

                                    }
                                    if (sub_feild.name === 'amount') {
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                        // excludes_schema['feilds'][key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;

                                    }
                                })
                            } else {
                                if (feild.key_word === 'add_more') {
                                    excludes_schema['feilds'][key].Specification.table_body.splice(table_key, 1);
                                }
                            }
                        }
                    })
                });
               
            }
            

        }
        
        if (page === 'recounselling') {
            const losStore = losReduxStore.getState();
            if (flag === 1) {
                if (data['nme_view_data']) {
                    const los = data['los']?data['los']:null;
                    if (nem_data_view.length > 0) {
                        nmePopupSchema.map((subTable, key) => {
                            let table_body = subTable.Specification.table_body;
                            nmePopupSchema[key].Specification.table_body.length=0
                            this.setState({ nmePopupSchema: nmePopupSchema });
                        })

                        nmePopupSchema.map((subTable, key) => {
                            let table_body = subTable.Specification.table_body;
                            nmePopupSchema[key].Specification.table_body.length=0
                            nem_data_view.map((item, skey) => {
                             console.log('ITEM=========================', item)
                                    let obj = {
                                        "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? (JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds']))) : [],
                                        id: skey + 1,
                                        input_feild: [],
                                        text: "Highend",
                                        'key_word': 'add_more',
                                        type: "text"

                                    }
                                    obj['feilds'].map((feild, key) => {
                                        obj['feilds'][key]['id'] = null;
                                        obj['feilds'][key]['value'] = null;
                                        obj['feilds'][key]['text'] = null;
                                    })
                                    obj['feilds'].map((feild, key) => {
                                        obj['feilds'][key]['id'] = skey + 1;
                                        if (feild.name === "unit") {
                                            obj['feilds'][key]['text'] = item.unit_id;
                                            obj['feilds'][key]['value'] = item.counselling_id;
                                        }
                                        if (feild.name === "department") {
                                            obj['feilds'][key]['title'] = item.nme_name;
                                            obj['feilds'][key]['value'] = item.nme_name;
                                            obj['feilds'][key]['disable'] = true;
                                        }
                                        if (feild.name === "description") {
                                            obj['feilds'][key]['title'] = item.nme_description;
                                            obj['feilds'][key]['value'] = item.nme_description;
                                            obj['feilds'][key]['disable'] = true;
                                        }
                                        if (feild.name === "tariff") {
                                            obj['feilds'][key]['title'] = item.nme_tariff;
                                            obj['feilds'][key]['value'] = item.nme_tariff;
                                            obj['feilds'][key]['disable'] = true;
                                        }
                                        if (feild.name === "rate") {
                                            obj['feilds'][key]['value'] = item.nme_rate;
                                            obj['feilds'][key]['text'] = item.nme_rate;

                                        }
                                        if (feild.name === "amount") {
                                            if (counselling_details && counselling_details.estimate_type === 1) {
                                                obj['feilds'][key]['value'] = item.nme_rate * losStore.data;
                                                obj['feilds'][key]['text'] = item.nme_rate * losStore.data;
                                            }else {
                                            obj['feilds'][key]['value'] = item.nme_rate * los;
                                            obj['feilds'][key]['text'] = item.nme_rate * los;
                                            }
                                        }
                                        if (feild.name === "action") {
                                            obj['feilds'][key]['element'] = 'action';
                                        }

                                    })
                                    subTable['Specification']['table_body'].push(obj);

                                this.setState({ nmePopupSchema: nmePopupSchema });
                            })
                        })
                    }
                    else {
                        nmePopupSchema.map((subTable, key) => {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                if (table_key === 0) {
                                    let row = feild.feilds;
                                    row.map((sub_feild, sub_table_key) => {
                                        if (sub_feild.name === "nmename") {
                                            nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                            nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null
                                            nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false


                                        }
                                        if (sub_feild.name === "description") {
                                            nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["title"] = null
                                            nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null
                                        }
                                        if (sub_feild.name === "amount") {
                                            nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                            nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null

                                        }

                                    })
                                } else {
                                    if (feild.key_word === 'add_more') {
                                        nmePopupSchema[key].Specification.table_body.splice(table_key, 2)

                                    }
                                }
                                this.setState({ nmePopupSchema: nmePopupSchema });
                            })

                        })
                    }
                hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema, status: false } })
                }
            }
        }
        let nmeValidation=data['showNMEModel']?data['showNMEModel']:null
        if(nmeValidation){
            this.setModal3Visible(true)
        }
    }

    next() {
        this.carousel.next();
    }
    previous() {
        this.carousel.prev();
    }

    handleChange(data) {
        let { nmePopupSchema } = this.state
        if (data.id !== '' && data.id !== undefined && data.id !== null) {
            nmePopupSchema.map((subTable, key) => {
                if (subTable.name === data.table) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name === "total" && sub_feild.id === data.id) {
                                    nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value;
                                    nmePopupSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = data.value;
                                }
                            
                        })

                    })
                }
            })
            this.setState({ nmePopupSchema: nmePopupSchema });
            hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema, status: false } })

        } else {
            nmePopupSchema.map((subTable, key) => {
                let table_name = data[0].feilds[0].table;
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    nmePopupSchema[key].Specification.table_body = table_body.concat(data);
                }
            });
            this.setState({ nmePopupSchema: nmePopupSchema });
            hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema, status: false } })

        }
        hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema, status: false } })
        let { medicationDetailsSchema } = this.props

    }

    handleInputChange = (e) => {
        const { name, value } = e.target;
    
        // Update the state variable with the new input value
        this.setState({
            inputValue: value
        });
    
        // Update the nmePopupSchema with the new value
        if (this.state.nmePopupSchema && this.state.nmePopupSchema.feilds && Array.isArray(this.state.nmePopupSchema.feilds)) {
            const updatedSchema = { ...this.state.nmePopupSchema };
    
            if (updatedSchema.feilds[0] && updatedSchema.feilds[0].Specification && updatedSchema.feilds[0].Specification.table_body[0] && updatedSchema.feilds[0].Specification.table_body[0].feilds) {
                updatedSchema.feilds[0].Specification.table_body[0].feilds[5].value = value;
            }
    
            this.setState({
                nmePopupSchema: updatedSchema
            });
        }
    }
    

    excludesIncludes() {
        console.clear();
    }
    feildChange(ele) {
        let { roomImages } = this.state
        let arr = [];
        let val = parseInt(ele);
        roomImages.forEach((res, key) => {
            if (res.room_id == ele) {
                arr.push(res.room_path);
            }
        });
        this.setState((state) => ({ 'rooms': arr }));

    }
    deleteRow(data) {
        let { nmePopupSchema } = this.state;
        let table_name = data[0].feilds[0].table;
        let last_id = data[0].feilds[0].id;
        if (Array.isArray(data)) {
            nmePopupSchema.map((subTable, key) => {
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (feild.id === last_id) {
                            nmePopupSchema[key].Specification.table_body.splice(table_key, 1);
                        }
                    })
                }
            })

        }
        this.setState({ nmePopupSchema: nmePopupSchema });
        hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema } })
    }
    handlePageChange(page) {
        this.setState((state) => ({
            page_no: page,
        }), () => {
            this.setModalConsent(true);
        })
    }
    setModalConsent(consentVisable){
        let {basic_info}=this.props;
       const Ip_no=basic_info.ip_no;
       let {consents_head,page_no}=this.state
       let user_data = JSON.parse(localStorage.getItem('user_data'));
    if(consentVisable){
        this.setState({loadding:true});
        try {
            postService('getConsentsDropDownForPatient', 'POST', { 'data': {"unit_id":  user_data['unitid'], "ip_no": Ip_no } }).then(res => {
                if (res.status) {
                    if (res['data'] && res['data'].length>0) {
                        this.setState((state) => ({
                            all_task_body: res['data'],
                            message: res.message,
                            totalItemsCount: res.total_items,
                            loadding: false
                        }));
                    }
                } else {
                    this.setState({ loadding: false })
                    Modal.error({
                        title: 'Failure',
                        content: res.message ? res.message : 'Oops! something is wrong. Please try again.',
                    })
                }
            })
        } catch (error) {
            this.setState((state) => ({ loadding: false }));

            Modal.error({
                title: 'Failure',
                content: 'Oops, something is wrong. Please try again.',
            })

        }
    }
        this.setState({consentviewModel:consentVisable,loadding:false})
    }
    commentsModal(data) {
        let { investigations, procedures, drugs } = this.state
            this.setState((state) => ({ viewModal: true, patient_details: data, loadding: true }));
            try {
                postService('getConsentsDetailsForPatient', 'POST', { 'data': { "consent_id": data.consent_id ? data.consent_id : null } }).then(res => {
                    if (res.status === true) {
                            this.setState((state) => ({
                                loadding: false,
                                investigations_body: res["data"].investigations,
                                durg_body: res['data'].drugs,
                                procedures_body: res['data'].procedures,
                                patient_details:res['data'],
                                patient_name:data.patient_name
                            }));
                    } else {
                        this.setState({
                            loadding: false, 
                            viewModal: false,
                            investigations_body: [],
                            durg_body: [],
                            procedures_body: []
                        })
                        Modal.error({
                            title: 'Failure',
                            content: res.message ? res.message : 'Oops! something is wrong. Please try again.',
                        })
                    }
                })
            } catch (error) {
                this.setState((state) => ({ loadding: false, viewModal: false }));

                Modal.error({
                    title: 'Failure',
                    content: 'Oops, something is wrong. Please try again.',
                })

            }
    }
    ConsentPrintModal(id){
        postService('getConsentsDetailsForPatient', 'POST', {
            'data': {
                "consent_id": id.consent_id ?
                id.consent_id : null,
            }
        }).then(res => {
            if (res.status) {
                let data=res['data'];
                if(data.is_counsellor_submitted===1){
                    let investigations_body=res['data'].investigations;
                    
                        res['data'].investigations.map((data, key) => {
                            Object.keys(data).map((dataKey) => {
                                if (dataKey === 'approval_status') {
                                    if (res.data['investigations'][key][dataKey] === 'approve') {
                                        res['data']['investigations'][key][dataKey] = 'approve' ? 'Approved' : 'Rejected';
                                    } else if (res.data['investigations'][key][dataKey] === 'reject') {
                                        res['data']['investigations'][key][dataKey] = 'reject' ? 'Rejected' : 'Approved';
                                    } 
                                }
                                })

                    })
                    res['data'].drugs.map((data, key) => {
                        Object.keys(data).map((dataKey) => {
                            if (dataKey === 'approval_status') {
                                if (res.data['drugs'][key][dataKey] === 'approve') {
                                    res['data']['drugs'][key][dataKey] = 'approve' ? 'Approved' : 'Rejected';
                                } 
                                else if (res.data['drugs'][key][dataKey] === 'reject') {
                                    res['data']['drugs'][key][dataKey] = 'reject' ? 'Rejected' : 'Approved';
                                } 
                            }
                            })
                            
                })
                res['data'].procedures.map((data, key) => {
                    Object.keys(data).map((dataKey) => {
                        if (dataKey === 'approval_status') {
                            if (res.data['procedures'][key][dataKey] === 'approve') {
                                res['data']['procedures'][key][dataKey] = 'approve' ? 'Approved' : 'Rejected';
                            } 
                            else if (res.data['procedures'][key][dataKey] === 'reject') {
                                res['data']['procedures'][key][dataKey] = 'reject' ? 'Rejected' : 'Approved';
                            } 
                        }
                        })
                        
            })
                    this.setState({investigations_body_print: investigations_body,durg_body_print: data.drugs,procedures_body_print: data.procedures,consent_details: data,loadding: false,consentdetalsvisible_print:true,consentPrintVisibles:false
                }); 
                }
               
            } else {
                this.setState({ loadding: false })
                Modal.error({
                    title: 'Failure',
                    content: res.message ? res.message : 'Oops! something is wrong. Please try again.',
                })
            }
        })
    }

    nmeExtraAmountChange = (e) => {
        let {nmePopupSchema}=this.state;
        let value = e.target.value;
        this.setState((state) => ({ nmeExtraAmount: value}));
        hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema, status: false, nmeInfo: value } })
    }

    render() {
        let { active_tab, payment_mode, includesSchema,excludesSchema, counselling_details,basic_info } = this.props;
        console.log('PATIENTDETAILS', this.props);
        console.log('PATIENTDETAILScounselling_details', this.props.counselling_details);
        let { slug } = this.props.match.params;
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        const cd = params.get('cd');

        // let { excludesSchema, includesSchema, rooms, roomtypeSchema, nmePopupSchema, hide,roomTabs } = this.state;
        let { rooms, roomtypeSchema, nmePopupSchema, hide, hiderooms, roomTabs,consents_head,all_task_body,consentviewModel,loadding,constentlistHead,procedures_head,procedures_body,drug_head,durg_body,investigations_head,investigations_body,patient_details,viewModal,patient_name,consent_details,investigations_body_print,durg_body_print,procedures_body_print, inputValue, tablebody } = this.state;
        let ex = [];
        let inc = [];
        // ex = (JSON.parse(JSON.stringify(excludesSchema['feilds'])));
        console.log("ex line 2016",ex);
        if (includesSchema === undefined) {
            let { includesSchema } = this.state;
            inc = includesSchema
            console.log("ex line 2020",inc);
        }
        else {
            includesSchema.map((subTable, key) => {
                if (subTable['title'] === '' && subTable['name'] === '') {
                    if (includesSchema[key].Specification.table_body.length === 0) {
                        includesSchema[key].Specification.table_head.length = 0
                    }
                }
                if (includesSchema[key].Specification.table_body.length !== 0 && includesSchema[key].Specification.table_head.length === 0) {
                    includesSchema[key].Specification.table_head.push({ 'id': 1, 'text': 'S.no', width: "5%" },{'id': 5, 'text': 'Package Name', width: "30%" }, { 'id': 2, 'text': 'Serivce Type', width: "15%" }, { 'id': 3, 'text': 'Dept./ServiceGroup', width: "25%" }, { 'id': 4, 'text': 'Service Name', width: "25%" }, { 'id': 6, 'text': 'Quantity', width: "18%" }, { 'id': 7, 'text': 'Rate (Rs.)', width: "18%" }, { 'id': 8, 'text': 'Amount (Rs.)', width: "18%" }, { 'id': 9, 'text': 'EquServiceCode', width: "18%" }, { 'id': 10, 'text': 'IsActive', width: "18%" }, { 'id': 11, 'text': 'Ward Name', width: "45%" },{ 'id': 12, 'text': 'Leve1 Desc', width: "45%" })
                }
            })
            inc = includesSchema
            console.log("ex line 2034",inc);
        }

        if (excludesSchema === undefined) {
            let { excludesSchema } = this.state;
            ex = excludesSchema
            console.log("ex line 2038",ex);
        }
        else {
            excludesSchema.map((subTable, key) => {
                if (subTable['title'] === '' && subTable['name'] === '') {
                    if (excludesSchema[key].Specification.table_body.length === 0) {
                        excludesSchema[key].Specification.table_head.length = 0
                    }
                }
                if (excludesSchema[key].Specification.table_body.length !== 0 && excludesSchema[key].Specification.table_head.length === 0) {
                    excludesSchema[key].Specification.table_head.push({ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "95%" })
                }
            })
            ex = excludesSchema
            console.log("ex line 2052",ex);
        }


        if (rid != '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling') {
            console.log('1111')
            slug = 'recounselling';
            if(counselling_details && moment(counselling_details['counselling_date']).isAfter(counselling_details['VERSION_UPDATED_DATE']) ){
             }else{
                 slug = 'finanical-counselling'; 
             }
            // if( cd != '' && cd !== undefined && cd !== null && !isNaN(cd)){
            //     disabled = true;
            // }
        }
        else if (slug === 'view-finanical-counselling') {
            slug = 'view-finanical-counselling';
            console.log('2222')
        }
        else {
            slug = 'finanical-counselling';
            console.log('3333')
        }


        let { base_url } = networkList;
        const { TabPane } = Tabs;
        const Trarif = this.props;
        // let NMEDTA = nmePopupSchema[0].Specification.table_body[0].feilds[3].value;
        // console.log('NMENMEDES::', nmePopupSchema[0].Specification.table_body[0].feilds[3].value, this.state);
        // const columns = [
        //     { title: 'S.No', dataIndex: 'sno' },
        //     { title: 'Unit Name', dataIndex: 'unitName' },
        //     { title: 'Department', dataIndex: 'department' },
        //     { title: 'Description', dataIndex: 'description' },
        //     { title: 'Tariff', dataIndex: 'tariff' },
        //     { title: 'Rate', dataIndex: 'rate' },
        //     { title: 'Amount', dataIndex: 'amount' },
        //   ];

        //   const dataSource = [];
        return (<React.Fragment>
            {/* <InsurancePreview /> */}
            <div className="position-fixed side-menu-wizard">
                <div className="row my-2 mx-0">
                    <div className="scroll">
                     {/* upload documents */}
                     {/* {this.props.form_openn === 3 || this.props.form_type === 2 ? null : <AdmissionAdvices {...this.props} {...this.state} />} */}
                     {(tablebody && tablebody.length > 0) ? <AdmissionAdvices {...this.props} {...this.state}/> : null}
                     {/* <Counselling_upload {...this.props} {...this.state} /> */}
                     {/* <New_Counselling_upload {...this.props} {...this.state} /> */}
                     {this.props.form_openn === 3 || this.props.form_type === 2 ? null : <New_Counselling_upload {...this.props} {...this.state} />}
                    {/* financial clearance */}
                    <Finanical_clearance {...this.props} {...this.state} />
                    
                    {/* hide show in insurance only */}
                      {/* rooms modal */}
                {!hiderooms && <div className="col-10 mb-2 icon mx-auto p-3 text-center" style={{ backgroundColor: '#b37f40',marginTop:'10px' }} onClick={() => this.setModal4Visible(true)}>
                        <HomeFilled style={{ fontSize: 18, color: '#ffff' }} />
                        <p className="mt-2 mb-0">Rooms</p>
                    </div>}

                    <PatientCheckIn {...this.props} {...this.state} />
                    {/* show NME popup in insurance only */}
                    {payment_mode === 2 && <div className="col-10 mb-2 icon mx-auto p-3 text-center" style={{ backgroundColor: '#218838' }} onClick={() => this.setModal3Visible(true)}>
                        <InfoCircleFilled style={{ fontSize: 18, color: '#ffff' }} />
                        <p className="mt-2 mb-0">NME</p>
                    </div>}
                    <div className={hide ? 'mhide' : 'mshow'} id='inex'>
                        {/* includes */}
                        <div className={`col-10 mb-2 icon mx-auto p-3 text-center ${active_tab === 1 ? '' : 'not-active'}`} style={{ backgroundColor: '#218838' }} onClick={() => this.setModal1Visible(true)}>
                            <PlusCircleFilled style={{ fontSize: 18, color: '#ffff' }} />
                            <p className="mt-2 mb-0">Includes</p>
                        </div>
                        {/* excludes */}
                        <div className={`col-10 mb-2 icon mx-auto p-3 text-center ${active_tab === 1 ? '' : 'not-active'}`} style={{ backgroundColor: '#218838' }} onClick={() => this.setModal2Visible(true)}>
                            <MinusCircleFilled style={{ fontSize: 18, color: '#ffff' }} />
                            <p className="mt-2 mb-0">Excludes</p>
                        </div>
                    </div>
                    {basic_info.ip_no&&<div className="col-10 mb-2 icon mx-auto p-3 text-center" style={{ backgroundColor: '#40a7b3' }} onClick={() => this.setModalConsent(true)}>
                        <FileDoneOutlined style={{ fontSize: 18, color: '#ffff' }} />
                        <p className="mt-2 mb-0">Consents</p>
                    </div>}
                    
                    

                    <Modal
                        // title="Includes"
                        centered
                        visible={this.state.modal1Visible}
                        onOk={() => this.includesOK()}
                        onCancel={() => this.setModal1Visible(false)}
                        // width={1000}
                        width='90%'
                        // height='100%'
                        footer={null}
                    >

                        <React.Fragment>
                            <Tooltip title='Close'><CloseOutlined type="close" className=" popup-close" onClick={() => this.setModal1Visible(false)} /></Tooltip>
                            <h3 className="data-label w-100 mb-3 " style={{ fontSize: 20, textAlign: 'center' }}>Includes</h3>
                            <div className="financial-table table-responsive">
                                {inc.map((feild, key) => {
                                    if (feild.visible) {
                                        console.log('INTAB', feild.Specification.table_body);
                                        return (<React.Fragment key={key}>
                                            <div className="d-inline-flex pl-5 w-100">
                                                <h4 className="data-label w-100" style={{ fontSize: 12 }}>{feild.title}</h4>
                                            </div>
                                            <div className="financial-table table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                                {feild.Specification.table_body.length > 0 ? 
                                                <Tableantd {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} slug={slug} />
                                                :                       
                                                <Spin size="large" />
                                                }
                                            </div>
                                        </React.Fragment>)
                                    }
                                })}
                            </div>
                        </React.Fragment>
                    </Modal>

                    <Modal
                        // title="Excludes"
                        centered
                        visible={this.state.modal2Visible}
                        onOk={() => this.excludesOK()}
                        onCancel={() => this.setModal2Visible(false)}
                        // width={1000}
                        width='90%'
                        // height='100%'
                        footer={null}
                    >

                        <React.Fragment>
                            <div className="financial-table table-responsive">
                            <Tooltip title='Close'><CloseOutlined type="close" className=" popup-close" onClick={() => this.setModal2Visible(false)} /></Tooltip>
                                <h6 className="data-label w-100" style={{ fontSize: 20 }}>General Package Excludes:</h6>
                                <p className="one text-justify">    1. Any Investigation or pharmacy item beyond the limit defined in the package.</p>
                                <p className="one text-justify">    2. Food & Beverage availed by patient or attendant outside of dietician's plan.</p>
                                <p className="one text-justify">    3. Any consultation or procedure done that is outside of the primary line of treatment.</p>
                                <p className="one text-justify">    4. Extended stay beyond the duration of the package.</p>
                                <p className="one text-justify">    5. Any service rendered during the extended stay (Investigation, Procedure, Doctor Visits).</p>
                                {ex.map((feild, key) => {
                                    if (feild.visible) {

                                        return (<React.Fragment key={key}>
                                            {/* <div className="d-inline-flex pl-5 w-100"> */}
                                                <h4 className="data-label w-100" style={{ fontSize: 20 }}>{feild.title}:</h4>
                                            {/* </div> */}
                                            <div className="financial-table table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                                <Tableantd {...this.props} {...this.state}  table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} slug={slug} />
                                            </div>
                                        </React.Fragment>)
                                    }
                                })}
                            </div>
                        </React.Fragment>
                    </Modal>
                   
                    <Modal
                        // title="NME"
                        centered
                        visible={this.state.modal3Visible}
                        onOk={() => this.nmeOK()}
                        onCancel={() => this.setModal3Visible(false)}
                        // width={1000}
                        width={1317}
                    >

                        <React.Fragment>
                            <div className="financial-table table-responsive">
                                {nmePopupSchema && nmePopupSchema.map((feild, key) => {
                                    if (feild.visible) {
                                        return (<React.Fragment key={key}>
                                            <div className="d-inline-flex pl-5 w-100">
                                                <h4 className="data-label w-100" style={{ fontSize: 20 }}>{feild.title}</h4>
                                            </div>
                                            <div className="financial-table table-responsive">
                                                <Tableantd form_table={'nme'} {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} />
                                                {/* <Tableantd {...this.props} {...this.state} table_from="nmePopupSchema" table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} excludesIncludes={this.excludesIncludes.bind(this)} /> */}
                                            </div>
                                            <div style={{marginLeft: '77%', marginTop:'20px'}}>
                                            <label>Enter Amount</label>
                                            {(slug === "finanical-counselling" || slug === "recounselling") ? 
                                            <input onChange={
                                                this.nmeExtraAmountChange.bind(this)
                                            }
                                            value={this.state.nmeExtraAmount}
                                            />
                                            :
                                                <input onChange={(e) => {
                                                    const value = e.target.value;
                                                    hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema, status: false, nmeInfo: value } })
                                                }}
                                                value={this.props.counselling_details.nme_extra_amount}
                                                disabled={!(slug === "finanical-counselling" || slug === "recounselling")}
                                                />
                                    }
                                            </div>
                                        </React.Fragment>)
                                    }
                                })}
                            </div>
                        </React.Fragment>
                    </Modal>
                  
                   
                   
                  
                    <Modal
                        // title="Room Types"
                        centered
                        visible={this.state.modal4Visible}
                        width='100%'
                        height='90%'
                        zIndex={1012}
                        footer={null}
                    >

                        <React.Fragment>
                       
                            <div className="financial-table table-responsive">

                                <div className="mx-auto">
                                    <Tabs onChange={this.feildChange.bind(this)} >
                                        {roomTabs && roomTabs.map((feild, key) => {
                                            return (
                                                <TabPane tab={feild.name} key={feild.id} />
                                            )
                                        })
                                        }
                                    </Tabs>
                                    {/* {roomtypeSchema.map((feild, key) => {
                                        return (
                                            <Selectlayer {...this.props} {...this.state} key={key} feild_data={feild} inputChange={this.feildChange.bind(this)} />
                                        )
                                    }
                                    )} */}
                                </div>
                                <div className="mt-3">
                                    {rooms && Array.isArray(rooms) && rooms.length > 0
                                        ?
                                        <div>
                                            <LeftCircleOutlined onClick={this.previous} className="carousel-left" />
                                            <Carousel ref={node => (this.carousel = node)}>
                                                {rooms.map((feild, key) => {
                                                    return (<div>
                                                        <iframe src={`${base_url + 'room_images/' + feild+'#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true; disableprint=true'}`}  style={{ objectFit: 'contain', width: '100%', height: '500px' }} ></iframe>
                                                    </div>)
                                                })}
                                            </Carousel>
                                            <RightCircleOutlined onClick={this.next} className="carousel-right" />
                                        </div>
                                        :
                                        <div className="text-center" style={{ height: '430px' }}>
                                            <img src="https://img.pngio.com/index-of-wp-content-uploads-job-manager-uploads-companylogo-2018-08-thumbnail-png-992_680.png" style={{ objectFit: 'cover', width: '100%', height: '430px' }}></img>
                                        </div>
                                    }
                                    <Button key="back" className="btn btn-success float-right mt-3" onClick={() => this.setModal4Visible(false)}>Close</Button>
                                </div>
                            </div>
                        </React.Fragment>
                    </Modal>

                   {/*consent list   */}

                    <Modal
                        title=''
                        centere
                        footer={null}
                        width='95%'
                        zIndex='1021'
                        closable={false}
                        maskClosable={false}
                        visible={consentviewModel}>
                        <Spin spinning={loadding}>
                            <Tooltip title="Close"><CloseOutlined type="close" className="comments-popup-close" onClick={() => this.setState({ consentviewModel: false, comments: null })} /></Tooltip>
                            <div className="row bg-white">
                                <h4 className="data-label w-100 pt-3 text-center" style={{ fontSize: 20 }}>Consents</h4>
                                <div className="financial-table table-responsive bg-white">
                                {/* <div className="mx-auto"> */}
                                <table className="table table-hover table-bordered mb-0 bg-white">
                                        <thead className="table-header-bg-color">
                                            {constentlistHead.map((feild, key) => {
                                                    return (<th>{feild.text}</th>)
                                            })}
                                        </thead>
                                        <tbody className="">
                                            {all_task_body
                                                .map((data, tkey) => {
                                                    return (
                                                        <tr key={tkey}>
                                                            {constentlistHead.map((head, Hkey) => {
                                                                if (head['key'] === 's_no') {
                                                                    return (<td style={{ width: '5%' }}>{tkey + 1}</td>)
                                                                }
                                                                if (head['key'] === 'ip_no') {
                                                                    return (
                                                                        <td className="text-capitalize"><Tooltip title="Consent Details"><p style={{ 'cursor': 'pointer', 'color': 'blue' }} onClick={() => { this.commentsModal(data) }}>{data[head['key']] ? data[head['key']] : 'NA'}</p></Tooltip></td>
                                                                    )
                                                                }
                                                                if(head['key'] === 'print'){
                                                                    return (
                                                                         <td className="text-capitalize">{data.is_counsellor_submitted===1?<Tooltip title="Print Consent"><p style={{ 'cursor': 'pointer', 'color': 'blue' }} onClick={() => { this.ConsentPrintModal(data) }}>Print</p></Tooltip>:'--'}</td>
                                                                         )
                                                                }

                                                                return (
                                                                    <td>{(data[head['key']] !== null) ? data[head['key']] : '--'}</td>
                                                                )
                                                            })}
                                                        </tr>
                                                    )
                                                })
                                            }
                                            {(all_task_body && all_task_body.length === 0) && <React.Fragment>
                                                <tr>
                                                    <td colSpan={constentlistHead.length}>
                                                        <Empty description={
                                                            <span>
                                                                No Data
                                                            </span>
                                                        } />
                                                    </td>
                                                </tr>
                                            </React.Fragment>}
                                        </tbody>
                                    </table>
                                {/* <Table columns={consents_head} dataSource={all_task_body} className="consents_table" scroll={{ x: '150%'}}  pagination={{ position: ['bottomCenter'],showSizeChanger:false,pageSize:'20' }}/> */}
                                {/* </div> */}
                                {/* <Button key="back" className="btn btn-success float-right mt-3" onClick={() => this.setModalConsent(false)}>Close</Button> */}

                            </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col text-center">
                                    <button className="btn btn-next" onClick={() => this.setState({ consentviewModel: false })}>Close</button>
                                </div>
                            </div>
                        </Spin>
                    </Modal>

{/* consent Details */}
                    <Modal
                    title=''
                    centere
                    footer={null}
                    width='95%'
                    zIndex='1021'
                    closable={false}
                    maskClosable={false}
                    visible={viewModal}>
                    <Spin spinning={loadding}>
                        <Tooltip title="Close"><CloseOutlined type="close" className="comments-popup-close" onClick={() => this.setState({ viewModal: false, comments: null })} /></Tooltip>
                        <h4 className="text-center pb-4">Consent Details</h4>
                        <div className="row pb-3">
                            <div className="col-12 my-auto p-0">
                                <h6 className="mb-0"> <Tooltip title="Patient Name">{patient_details.patient_name ? patient_details.patient_name : patient_name}</Tooltip> <span className="mx-3">|</span> <Tooltip title="UMR Number">{patient_details.umr_no ? patient_details.umr_no : '--'}</Tooltip> <span className="mx-3">|</span> <Tooltip title="IP Number">{patient_details.ip_no ? patient_details.ip_no : '--'}</Tooltip>
                                <span className="mx-3">|</span><Tooltip title="Ward Name">{patient_details.ward_name ? patient_details.ward_name : '--'}</Tooltip> <span className="mx-3">|</span><Tooltip title="Nurse Station Name">{patient_details.nurse_station_name ? patient_details.nurse_station_name : '--'}</Tooltip></h6>
                            </div>
                        </div>
                        <div className="row ">
                            <h4 className="data-label w-50 pt-3" style={{ fontSize: 20 }}>Investigations</h4>
                            <div className="financial-table table-responsive sticky-header" id="table">
                                <table className="table table-hover table-bordered mb-0 bg-white">
                                    <thead className="table-header-bg-color">
                                        {investigations_head.map((feild, key) => {
                                            if (feild.visible === true) {
                                                return (<th>{feild.text}</th>)
                                            }
                                        })}
                                    </thead>
                                    <tbody className="">
                                        {investigations_body
                                            .map((data, tkey) => {
                                                return (
                                                    <tr key={tkey}>
                                                        {investigations_head.map((head, Hkey) => {
                                                            if (head['name'] === 's_no') {
                                                                return (<td style={{ width: '5%' }}>{tkey + 1}</td>)
                                                            }
                                                            if (head['name'] === 'investigation_name') {
                                                                return (<td style={{ width: '28%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'general_price') {
                                                                return (<td style={{ width: '12%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'price') {
                                                                return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'approval_status') {
                                                                if(data[head['name']]!==null && data[head['name']]==='approve'){
                                                                    return (<td style={{ lineHeight: '1.2rem', textTransform: 'capitalize' }}>{(data[head['name']] !== null) ? data[head['name']]+'d' : 'NA'}</td>)
                                                                }else{
                                                                    return (<td style={{ lineHeight: '1.2rem', textTransform: 'capitalize' }}>{(data[head['name']] !== null) ? 'Rejected' : 'NA'}</td>)
                                                                }
                                                            }
                                                            if (head['name'] === 'reject_reason') {
                                                                return (<td style={{ width: '20%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'created_at') {
                                                                return (<td style={{ width: '15%' }}>{(data['created_at']) ? moment(data['created_at']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                                // return ( <td>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            return (
                                                                <td>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>
                                                            )
                                                        })}
                                                    </tr>
                                                )
                                            })
                                        }
                                        {(investigations_body && investigations_body.length === 0) && <React.Fragment>
                                            <tr>
                                                <td colSpan={investigations_head.length}>
                                                    <Empty description={
                                                        <span>
                                                            No Data
                                                        </span>
                                                    } />
                                                </td>
                                            </tr>
                                        </React.Fragment>}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="row ">
                            <h4 className="data-label w-50 pt-3" style={{ fontSize: 20 }}>Drugs</h4>
                            <div className="financial-table table-responsive sticky-header" id="table">
                                <table className="table table-hover table-bordered mb-0 bg-white">
                                    <thead className="table-header-bg-color">
                                        {drug_head.map((feild, key) => {
                                            if (feild.visible === true) {
                                                return (<th>{feild.text}</th>)
                                            }
                                        })}
                                    </thead>
                                    <tbody className="">
                                        {durg_body
                                            .map((data, tkey) => {
                                                return (
                                                    <tr key={tkey}>
                                                        {drug_head.map((head, Hkey) => {
                                                            if (head['name'] === 's_no') {
                                                                return (<td style={{ width: '5%' }}>{tkey + 1}</td>)
                                                            }
                                                            if (head['name'] === 'drug_name') {
                                                                return (<td style={{ width: '31%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'drug_price') {
                                                                return (<td style={{ width: '13%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'price') {
                                                                return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'approval_status') {
                                                                if(data[head['name']]!==null && data[head['name']]==='approve'){
                                                                    return (<td style={{ lineHeight: '1.2rem', textTransform: 'capitalize' }}>{(data[head['name']] !== null) ? data[head['name']]+'d' : 'NA'}</td>)
                                                                }else{
                                                                    return (<td style={{ lineHeight: '1.2rem', textTransform: 'capitalize' }}>{(data[head['name']] !== null) ? 'Rejected' : 'NA'}</td>)
                                                                }
                                                            }

                                                            if (head['name'] === 'reject_reason') {
                                                                return (<td style={{ width: '20%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'created_at') {
                                                                return (<td style={{ width: '15%' }}>{(data['created_at']) ? moment(data['created_at']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                            }
                                                            return (
                                                                <td>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>
                                                            )
                                                        })}
                                                    </tr>
                                                )
                                            })
                                        }
                                        {(durg_body && durg_body.length === 0) && <React.Fragment>
                                            <tr>
                                                <td colSpan={drug_head.length}>
                                                    <Empty description={
                                                        <span>
                                                            No Data
                                                        </span>
                                                    } />
                                                </td>
                                            </tr>
                                        </React.Fragment>}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="row ">
                            <h4 className="data-label w-50 pt-3" style={{ fontSize: 20 }}>Procedures</h4>
                            <div className="financial-table table-responsive sticky-header" id="table">
                                <table className="table table-hover table-bordered mb-0 bg-white">
                                    <thead className="table-header-bg-color">
                                        {procedures_head.map((feild, key) => {
                                            if (feild.visible === true) {
                                                return (<th>{feild.text}</th>)
                                            }
                                        })}
                                    </thead>
                                    <tbody className="">
                                        {procedures_body
                                            .map((data, tkey) => {
                                                return (
                                                    <tr key={tkey}>
                                                        {procedures_head.map((head, Hkey) => {
                                                            if (head['name'] === 's_no') {
                                                                return (<td style={{ width: '5%' }}>{tkey + 1}</td>)
                                                            }
                                                            if (head['name'] === 'procedure_name') {
                                                                return (<td style={{ width: '28%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'general_price') {
                                                                return (<td style={{ width: '12%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'price') {
                                                                return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'approval_status') {
                                                                if(data[head['name']]!==null && data[head['name']]==='approve'){
                                                                    return (<td style={{ lineHeight: '1.2rem', textTransform: 'capitalize' }}>{(data[head['name']] !== null) ? data[head['name']]+'d' : 'NA'}</td>)
                                                                }else{
                                                                    return (<td style={{ lineHeight: '1.2rem', textTransform: 'capitalize' }}>{(data[head['name']] !== null) ? 'Rejected' : 'NA'}</td>)
                                                                }
                                                            }
                                                            if (head['name'] === 'reject_reason') {
                                                                return (<td style={{ width: '20%' }}>{(data[head['name']] !== null) ? data[head['name']]: 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'created_at') {
                                                                return (<td style={{ width: '15%' }}>{(data['created_at']) ? moment(data['created_at']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                            }
                                                            return (
                                                                <td>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>
                                                            )
                                                        })}
                                                    </tr>
                                                )
                                            })
                                        }
                                        {(procedures_body && procedures_body.length === 0) && <React.Fragment>
                                            <tr>
                                                <td colSpan={procedures_head.length}>
                                                    <Empty description={
                                                        <span>
                                                            No Data
                                                        </span>
                                                    } />
                                                </td>
                                            </tr>
                                        </React.Fragment>}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col text-center">
                                <button className="btn btn-next" onClick={() => this.setState({ viewModal: false })}>Close</button>
                            </div>
                        </div>
                    </Spin>
                </Modal>
{/* consent Print */}
                <Modal
                                        // title="Clearance"
                                        centered
                                        visible={this.state.consentdetalsvisible_print}
                                        footer={null}
                                        onOk={() => this.setState({consentdetalsvisible_print:false})}
                                        onCancel={() => this.setState({consentdetalsvisible_print:false})}
                                        width='100%'
                                        zIndex={1021}
                                    >
                                        <Spin spinning={this.state.loadding}>
                                            <div ref={(el) => (this.componentRef = el)} >
                                                <React.Fragment>
                                                    <div className="fc-patient-copy">
                                                        <div className="p-4 bg-white" id="myH1">
                                                            <div className="clearfix">
                                                                <img src="/assets/images/logo-black.png" alt="Kims" className="float-left"></img>
                                                                {/* <p className="float-right align-middle pb-0 my-2 ">KIMS-K/BILL/F/B/03</p> */}
                                                            </div>

                                                            <div>
                                                                <h1 className="text-p-bold text-center text-uppercase py-4">Consent Form</h1>
                                                            </div>
                                                            <div className="row pb-3">
                                <div className="col-3 my-auto ">
                                    <h6 className="mb-0">Consent ID : {consent_details['consent_id'] ? consent_details['consent_id'] : '--'}</h6>
                                    </div>
                                    <div className="col-3 my-auto ">
                                     <h6 >Nurse : {consent_details['nurse'] ? consent_details['nurse'] : '--'}</h6> 
                                  </div>
                                  <div className="col-3 my-auto capitalize_consent">
                                  <h6>Counsellor : {consent_details['counsellor'] ? consent_details['counsellor'] : '--'}</h6>
                                     </div> 
                                     <div className="col-3 my-auto ">
                                  <h6>UMR Number : {consent_details.umr_no ? consent_details.umr_no : '--'}</h6>
                                     </div> 
                                     <div className="col-3 my-auto pt-2  pr-0 pb-0">
                                  <h6>IP Number : {consent_details.ip_no ? consent_details.ip_no : '--'}</h6>
                                     </div> 
                            </div>
                                 <div className="row p-3">
                                <h4 className="data-label w-50 pt-3" style={{ fontSize: 20 }}>Investigations</h4>
                                    <table className="table table-hover table-bordered ">
                                        <thead>
                                            {investigations_head.map((feild, key) => {
                                                if (feild.visible === true) {
                                                    return (<th className="text-capitalize">{feild.text}</th>)
                                                }
                                            })}
                                        </thead>
                                        <tbody >
                                            {investigations_body_print
                                                .map((data, tkey) => {
                                                    return (
                                                        <tr key={tkey}>
                                                            {investigations_head.map((head, Hkey) => {
                                                                if (head['name'] === 's_no') {
                                                                    return (<td style={{ width: '5%' }}>{tkey + 1}</td>)
                                                                }
                                                                if (head['name'] === 'investigation_name') {
                                                                    return (<td style={{ width: '35%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'price') {
                                                                    return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'status') {
                                                                    return (<td style={{ lineHeight: '1.2rem', width: '15%' }}>{(data[head['name']]==='approve') ? 'Approved':'Rejected'}</td>)
                                                                }
                                                                if (head['name'] === 'reject_reason') {
                                                                    return (<td style={{ width: '20%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'created_at') {
                                                                    return (<td style={{ width: '15%' }}>{(data['created_at']) ? moment(data['created_at']).format('DD-MM-YYYY HH:mm') : '--'}</td>)
                                                                    // return ( <td>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                return (
                                                                    <td>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>
                                                                )
                                                            })}
                                                        </tr>
                                                    )
                                                })
                                            }
                                            {(investigations_body_print && investigations_body_print.length === 0) && <React.Fragment>
                                                <tr>
                                                    <td colSpan={investigations_head.length}>
                                                        <Empty description={
                                                            <span>
                                                                No Data
                                                            </span>
                                                        } />
                                                    </td>
                                                </tr>
                                            </React.Fragment>}
                                        </tbody>
                                    </table>
                            </div>

                            <div className="row p-3">
                                <h4 className="data-label w-50 pt-3" style={{ fontSize: 20 }}>Drugs</h4>
                                    <table className="table table-hover table-bordered ">
                                        <thead>
                                            {drug_head.map((feild, key) => {
                                                if (feild.visible === true) {
                                                    return (<th className="text-capitalize">{feild.text}</th>)
                                                }
                                            })}
                                        </thead>
                                        <tbody >
                                            {durg_body_print
                                                .map((data, tkey) => {
                                                    return (
                                                        <tr key={tkey}>
                                                            {drug_head.map((head, Hkey) => {
                                                                if (head['name'] === 's_no') {
                                                                    return (<td style={{ width: '5%' }}>{tkey + 1}</td>)
                                                                }
                                                                if (head['name'] === 'drug_name') {
                                                                    return (<td style={{ width: '35%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'quantity') {
                                                                    return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'drug_price') {
                                                                    return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'price') {
                                                                    return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'status') {
                                                                    return (<td style={{ lineHeight: '1.2rem', width: '15%' }}>{(data[head['name']]==='approve') ? 'Approved':'Rejected'}</td>)
                                                                }

                                                                if (head['name'] === 'reject_reason') {
                                                                    return (<td style={{ width: '20%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'created_at') {
                                                                    return (<td style={{ width: '15%' }}>{(data['created_at']) ? moment(data['created_at']).format('DD-MM-YYYY HH:mm') : '--'}</td>)
                                                                }
                                                                return (
                                                                    <td>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>
                                                                )
                                                            })}
                                                        </tr>
                                                    )
                                                })
                                            }
                                            {(durg_body_print && durg_body_print.length === 0) && <React.Fragment>
                                                <tr>
                                                    <td colSpan={drug_head.length}>
                                                        <Empty description={
                                                            <span>
                                                                No Data
                                                            </span>
                                                        } />
                                                    </td>
                                                </tr>
                                            </React.Fragment>}
                                        </tbody>
                                    </table>
                            </div>

                            <div className="row p-3">
                                <h4 className="data-label w-50 pt-3" style={{ fontSize: 20 }}>Procedures</h4>
                                    <table className="table table-hover table-bordered">
                                        <thead>
                                            {procedures_head.map((feild, key) => {
                                                if (feild.visible === true) {
                                                    return (<th className="text-capitalize">{feild.text}</th>)
                                                }
                                            })}
                                        </thead>
                                        <tbody>
                                            {procedures_body_print
                                                .map((data, tkey) => {
                                                    return (
                                                        <tr key={tkey}>
                                                            {procedures_head.map((head, Hkey) => {
                                                                if (head['name'] === 's_no') {
                                                                    return (<td style={{ width: '5%' }}>{tkey + 1}</td>)
                                                                }
                                                                if (head['name'] === 'procedure_name') {
                                                                    return (<td style={{ width: '35%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }

                                                                if (head['name'] === 'price') {
                                                                    return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'status') {
                                                                    return (<td style={{ lineHeight: '1.2rem', width: '15%' }}>{(data[head['name']]==='approve') ? 'Approved':'Rejected'}</td>)
                                                                }
                                                                if (head['name'] === 'reject_reason') {
                                                                    return (<td style={{ width: '20%' }}>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>)
                                                                }
                                                                if (head['name'] === 'created_at') {
                                                                    return (<td style={{ width: '15%' }}>{(data['created_at']) ? moment(data['created_at']).format('DD-MM-YYYY HH:mm') : '--'}</td>)
                                                                }
                                                                return (
                                                                    <td>{(data[head['name']] !== null) ? data[head['name']] : '--'}</td>
                                                                )
                                                            })}
                                                        </tr>
                                                    )
                                                })
                                            }
                                            {(procedures_body_print && procedures_body_print.length === 0) && <React.Fragment>
                                                <tr>
                                                    <td colSpan={procedures_head.length}>
                                                        <Empty description={
                                                            <span>
                                                                No Data
                                                            </span>
                                                        } />
                                                    </td>
                                                </tr>
                                            </React.Fragment>}
                                        </tbody>
                                    </table>
                            </div>
                                                            
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            </div>
                                            <div className="fc-patient-copy">
                                                <div className="row justify-content-center p-4 pt-4 m-0">
                                                    <ReactToPrint
                                                        // trigger={() => <a href="#">Print this out!</a>}
                                                        trigger={() => <button className="btn btn-success d-print-none text-capitalize">Print</button>}
                                                        content={() => this.componentRef}
                                                    />
                                                    <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.setState({consentdetalsvisible_print:false})}>cancel</button>
                                                </div>
                                            </div>
                                        </Spin>
                                    </Modal>
                </div>
                </div>
            </div>

        </React.Fragment>)
    }
}
export default Side_feild;